import { useQuery } from '@apollo/client';
import {
    GetTripsHistoryDRIVERIdResponse,
    GetTripsHistoryDRIVERIdRequest,
    CITRIN_GET_TRIPS_DRIVER_HISTORY,
} from '../index';
import { TripsHistoryFetchInputMgt } from '../../shared/types';

export const useGetTripsHistoryByDriverIdQuery = (request: TripsHistoryFetchInputMgt) => {
    const { data, previousData, error, loading, ...rest } = useQuery<
        GetTripsHistoryDRIVERIdResponse,
        GetTripsHistoryDRIVERIdRequest
    >(CITRIN_GET_TRIPS_DRIVER_HISTORY, {
        variables: { request },
        skip: !request?.id,
        fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Riders', data),
        // onError: (error) => console.error('Error fetching invoices history:', error),
    });

    return {
        ...rest,
        loading,
        data: data?.CITRIN_MGT_getTripsHistoryByDriverId,
        previousData: previousData?.CITRIN_MGT_getTripsHistoryByDriverId,
    };
};
